<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2"><a id="page_ix">Abbreviations</a></h1><a id="page_ix">
<table>
<tbody>
<tr>
<td class="col1"><p class="t-left"><em>ANRW</em></p></td>
<td class="col2"><p class="t-left"><em>Aufstieg und Niedergang der römischen Welt</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Ant.</em></p></td>
<td class="col2"><p class="t-left">Josephus, <em>Antiquities of the Jews</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BAGD</p></td>
<td class="col2"><p class="t-left">W. Bauer, W. F. Arndt, F. W. Gingrich, and F. W. Danker, <em>Greek-English Lexicon of the New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BECNT</p></td>
<td class="col2"><p class="t-left">Baker Exegetical Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BTB</em></p></td>
<td class="col2"><p class="t-left"><em>Biblical Theology Bulletin</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">CEV</p></td>
<td class="col2"><p class="t-left">Contemporary English Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>EvQ</em></p></td>
<td class="col2"><p class="t-left"><em>Evangelical Quarterly</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>HTR</em></p></td>
<td class="col2"><p class="t-left"><em>Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JSNT</em></p></td>
<td class="col2"><p class="t-left"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">JSNTS</p></td>
<td class="col2"><p class="t-left">Journal for the Study of the New Testament Supplement</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JTS</em></p></td>
<td class="col2"><p class="t-left"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">LCL</p></td>
<td class="col2"><p class="t-left">Loeb Classical Library</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">LXX</p></td>
<td class="col2"><p class="t-left">Septuagint</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NA26</p></td>
<td class="col2"><p class="t-left">Nestle-Aland <em>Greek New Testament,</em> 26th ed.</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NAB</p></td>
<td class="col2"><p class="t-left">New American Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NEB</p></td>
<td class="col2"><p class="t-left">New English Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NICNT</p></td>
<td class="col2"><p class="t-left">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NIGTC</p></td>
<td class="col2"><p class="t-left">New International Greek Testament Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NovT</em></p></td>
<td class="col2"><p class="t-left"><em>Novum Testamentum</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NPNF</p></td>
<td class="col2"><p class="t-left">Nicene and Post-Nicene Fathers</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NRSV</p></td>
<td class="col2"><p class="t-left">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NT</p></td>
<td class="col2"><p class="t-left">New Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NTS</em></p></td>
<td class="col2"><p class="t-left"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">OT</p></td>
<td class="col2"><p class="t-left">Old Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">par.</p></td>
<td class="col2"><p class="t-left">parallel(s)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RSR</em></p></td>
<td class="col2"><p class="t-left"><em>Recherches de science religieuse</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><a id="page_x">RSV</a></p></td>
<td class="col2"><p class="t-left">Revised Standard Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SBLDS</p></td>
<td class="col2"><p class="t-left">Society of Biblical Literature Dissertation Series</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">SNTSMS</p></td>
<td class="col2"><p class="t-left">Society for New Testament Studies Monograph Series</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TDNT</em></p></td>
<td class="col2"><p class="t-left">G. Kittel and G. Friedrich, eds., <em>Theological Dictionary of the New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ThZ</em></p></td>
<td class="col2"><p class="t-left"><em>Theologische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">WBC</p></td>
<td class="col2"><p class="t-left">Word Biblical Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ZNW</em></p></td>
<td class="col2"><p class="t-left"><em>Zeitschrift für die neutestamentliche Wissenschaft</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ZTK</em></p></td>
<td class="col2"><p class="t-left"><em>Zeitschrift für Theologie und Kirche</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Abbreviations.vue?dfdb176e